/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Program_Audio_HelpInputs */

const en_audio_description_export_program_audio_help = /** @type {(inputs: Audio_Description_Export_Program_Audio_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leave empty to use project media`)
};

const fr_audio_description_export_program_audio_help = /** @type {(inputs: Audio_Description_Export_Program_Audio_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laissez vide pour utiliser le média du projet`)
};

const de_audio_description_export_program_audio_help = /** @type {(inputs: Audio_Description_Export_Program_Audio_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lassen Sie dieses Feld leer, um Projektmedien zu verwenden.`)
};

const it_audio_description_export_program_audio_help = /** @type {(inputs: Audio_Description_Export_Program_Audio_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lasciare vuoto per utilizzare il supporto del progetto`)
};

const ru_audio_description_export_program_audio_help = /** @type {(inputs: Audio_Description_Export_Program_Audio_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Оставьте поле пустым, чтобы использовать медиафайлы проекта.`)
};

const es_audio_description_export_program_audio_help = /** @type {(inputs: Audio_Description_Export_Program_Audio_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Déjelo vacío para utilizar los medios del proyecto`)
};

const zh_cn2_audio_description_export_program_audio_help = /** @type {(inputs: Audio_Description_Export_Program_Audio_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`留空以使用项目介质`)
};

const ja_audio_description_export_program_audio_help = /** @type {(inputs: Audio_Description_Export_Program_Audio_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロジェクトメディアを使用するには空白のままにしてください`)
};

const hi_audio_description_export_program_audio_help = /** @type {(inputs: Audio_Description_Export_Program_Audio_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रोजेक्ट मीडिया का उपयोग करने के लिए इसे खाली छोड़ दें`)
};

const pt_pt2_audio_description_export_program_audio_help = /** @type {(inputs: Audio_Description_Export_Program_Audio_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deixe em branco para usar a mídia do projeto.`)
};

/**
* | output |
* | --- |
* | "Leave empty to use project media" |
*
* @param {Audio_Description_Export_Program_Audio_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_program_audio_help = /** @type {((inputs?: Audio_Description_Export_Program_Audio_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Program_Audio_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_program_audio_help(inputs)
	if (locale === "de") return de_audio_description_export_program_audio_help(inputs)
	if (locale === "it") return it_audio_description_export_program_audio_help(inputs)
	if (locale === "ru") return ru_audio_description_export_program_audio_help(inputs)
	if (locale === "es") return es_audio_description_export_program_audio_help(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_program_audio_help(inputs)
	if (locale === "ja") return ja_audio_description_export_program_audio_help(inputs)
	if (locale === "hi") return hi_audio_description_export_program_audio_help(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_program_audio_help(inputs)
	return en_audio_description_export_program_audio_help(inputs)
});